import React from 'react'
import { TweenMax } from 'gsap'
import FancySelect from './FancySelect/FancySelect'

const FancySelectExpiry = (props) => {
    const hasErrors = () => {
        return props.errors && (props.errors.cardMonth || props.errors.cardYear)
    }

    const Errors = () => {
        return (
            <div className='col-12'>
                <div className='inline-error'>{props.errors.cardMonth ? props.errors.cardMonth[0] : props.errors.cardYear[0]}</div>
            </div>
        )
    }

    const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
    const years = () => {
        const date = (new Date()).getFullYear()
        const years = []

        for (let i = date; i <= (date + 10); i++) {
            years.push(String(i))
        }

        return years
    }

    return (
        <div className='fancy-toggle'>
            <div className='form-control my-4 my-md-3'>
                <label>Expiry date</label>
                <div>
                    <div className='row'>
                        <div className='col-6'>
                            <FancySelect
                                label='Month'
                                value={props.cardMonth}
                                list={months}
                                className={hasErrors() ? 'error' : ''}
                                setValue={value => props.handleChange({ cardMonth: value })}
                            />
                        </div>
                        <div className='col-6'>
                            <FancySelect
                                label='Year'
                                value={props.cardYear}
                                list={years()}
                                className={hasErrors() ? 'error' : ''}
                                setValue={value => props.handleChange({ cardYear: value })}
                            />
                        </div>
                        {hasErrors() ? Errors() : ''}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FancySelectExpiry



// WEBPACK FOOTER //
// ./resources/js/elements/FancySelectExpiry.js